<template>
  <section>
    <form action v-on:submit.prevent="createDocument">
      <div class="modal-card" style="height: 1000px; width: 100%">
        <header class="modal-card-head">
          <p>Crear Documento</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <div class="columns is-mobile is-desktop">
            <div class="column">
              <b-field
                label="Fecha del documento en papel"
                :label-position="'on-border'"
              >
                <b-datepicker
                  v-model="document.date_document"
                  :locale="'en-US'"
                  placeholder="Seleccionar Fecha"
                   :day-names="calendario.dias"
  :month-names="calendario.meses"
                  icon="calendar-alt"
                  trap-focus
                  required
                >
                </b-datepicker>
              </b-field>
              <b-field
                label="Número de documento"
                :label-position="'on-border'"
              >
                <b-input v-model="document.number" required></b-input>
              </b-field>
              <b-field label="Descripción" :label-position="'on-border'">
                <b-input
                  v-model="document.description"
                  type="textarea"
                  required
                ></b-input>
              </b-field>
              <b-field label="Tipo de documento" :label-position="'on-border'">
                <b-select
                  placeholder="Seleccionar tipo  de documento"
                  v-model="document.document_type_id"
                  expanded
                  required
                >
                  <option
                    v-for="option in listDocumentType"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field
                label="Seleccionar tipo de remitente"
                :label-position="'on-border'"
              >
                <b-select
                  placeholder="Seleccionar tipo de remitente"
                  v-model="document.type_remitent_id"
                  expanded
                  required
                  @change.native="changeSelect"
                >
                  <option
                    v-for="option in listTypeRemitent"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field
                v-if="document.type_remitent_id !== 3"
                label="Seleccionar remitente"
                :label-position="'on-border'"
              >
                <b-select
                  placeholder="Seleccionar remitente"
                  v-model="document.remitent_id"
                  expanded
                  required
                  :loading="loadingSelect"
                >
                  <option
                    v-for="option in listRemitent"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Archivo" :label-position="'on-border'">
                <b-upload v-model="document.file" class="file-label" required>
                  <span class="file-cta">
                    <b-icon class="file-icon" icon="upload"></b-icon>
                    <span class="file-label"
                      >Haga click aqui para seleccionar archivo</span
                    >
                  </span>
                  <span class="file-name" v-if="document.file">
                    {{ document.file.name }}
                  </span>
                </b-upload>
              </b-field>
            </div>
            <div class="column">
              <div>
                <b-field label="Seleccionar Distribución"></b-field>
                <b-field>
                  <b-radio-button
                    v-model="document.with_distribution"
                    :native-value="false"
                    type="is-danger"
                  >
                    <b-icon icon="times"></b-icon>
                    <span>No</span>
                  </b-radio-button>

                  <b-radio-button
                    v-model="document.with_distribution"
                    :native-value="true"
                    type="is-success"
                  >
                    <b-icon icon="check"></b-icon>
                    <span>Si</span>
                  </b-radio-button>
                </b-field>
              </div>
              <br />
              <b-field
                v-if="document.with_distribution"
                label="Lista de distribución"
                :label-position="'on-border'"
              >
                <b-taginput
                  v-model="selectedDistribution"
                  :data="filteredTags"
                  autocomplete
                  open-on-focus
                  field="name"
                  icon="tags"
                  placeholder="Favor de escribir para buscar en listado"
                  @typing="getFilteredTags"
                >
                </b-taginput>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import moment from "moment";
// import { postDocument } from "../../../services/document";
// import { getDocumentType } from "../../../services/document_type";
// import { getCellar } from "../../../services/cellar";
// import { getRemitentFindByType } from "../../../services/remitent";
// import { getTypeRemitent } from "../../../services/type_remitent";
import { DocumentTypeService } from "../../../services/models/document_type";
import { CellarService } from "../../../services/models/cellar";
import { RemitentService } from "../../../services/models/remitent";
import { TypeRemitentService } from "../../../services/models/type_remitent";
import { DocumentService } from "../../../services/models/document";
import { DistributionService } from "../../../services/models/distribution";
import { Document_DistributionService } from "../../../services/models/document_distribution";

export default {
  props: ["chargeDocumentList", "directory_id"],
  data() {
    return {
      selectedDistribution: [],
      openOnFocus: true,
      listDistributions: [],
      filteredTags: this.listDistributions,

      isLoading: false,
      loadingSelect: false,
      listDocumentType: [],
      listCellar: [],
      listRemitent: [],
      listTypeRemitent: [],
      document: {
        number: null,
        description: null,
        date_document: null,
        file: null,
        favorite: false,
        document_type_id: null,
        cellar_id: this.$route.params.cellarId ? this.$route.params.cellarId : this.$route.params.id,
        remitent_id: null,
        type_remitent_id: 1,
        directory_id: this.directory_id == null ? null : this.directory_id,
        state_directory:
          this.directory_id == null ? "Sin Directorio" : "Con Directorio",
        with_distribution: false,
      },
       calendario: {
          meses: [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
          ],
          dias: [
            'do',
            'lu',
            'ma',
            'mi',
            'ju',
            'vi',
            'sá',
          ],
        },
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    getFilteredTags(text) {
      this.filteredTags = this.listDistributions.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    async chargeData() {
      this.isLoading = true;
      const { data: documentTypes } = await DocumentTypeService.getAll();
      this.listDocumentType = documentTypes.data;      
      // this.listDocumentType = await getDocumentType(this.$http);
      const { data: cellars } = await CellarService.getAll();
      this.listCellar = cellars.data;
      // this.listCellar = await getCellar(this.$http);
      const { data: remitents } = await RemitentService.getRemitentFindByType(
        this.document.type_remitent_id
      );
      this.listRemitent = remitents;
      // this.listRemitent = await getRemitentFindByType(this.$http,this.document.type_remitent_id);
      const { data: remitentTypes } = await TypeRemitentService.getAll();
      this.listTypeRemitent = remitentTypes.data;
      // this.listTypeRemitent = await getTypeRemitent(this.$http);
      const { data: distributions } = await DistributionService.getAll();
      this.listDistributions = distributions.data;

      this.isLoading = false;
    },
    async changeSelect() {
      this.loadingSelect = true;
      const { data: remitents } = await RemitentService.getRemitentFindByType(
        this.document.type_remitent_id
      );
      this.listRemitent = remitents;
      // this.listRemitent = await getRemitentFindByType(this.$http,this.document.type_remitent_id);
      this.loadingSelect = false;
    },
    async createDocument() {
      if(this.document.date_document!=null){
        this.isLoading = true;
        let formData = new FormData();
        formData.append("with_distribution", this.document.with_distribution);
        formData.append("number", this.document.number);
        formData.append("description", this.document.description);
        formData.append(
          "date_document",
          moment(this.document.date_document).format("YYYY-MM-DD")
        );
        formData.append("file", this.document.file);
        formData.append("favorite", this.document.favorite);
        formData.append("document_type_id", this.document.document_type_id);
        formData.append("cellar_id", this.document.cellar_id);
        if (this.document.type_remitent_id != 3) {
          formData.append("remitent_id", this.document.remitent_id);
        }
        formData.append("type_remitent_id", this.document.type_remitent_id);
        if (this.document.directory_id != null) {
          formData.append("directory_id", this.document.directory_id);
        }
        formData.append("state_directory", this.document.state_directory);
        try {
          const { data: document } = await DocumentService.create(formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (this.document.with_distribution) {
            for (let i = 0; i < this.selectedDistribution.length; i++) {
              let data = {
                document_id: document.id,
                distribution_id: this.selectedDistribution[i].id,
              };
              await Document_DistributionService.create(data);
            }
          }
          this.$buefy.notification.open({
            message: "Documento Ingresado!",
            type: "is-success",
          });
          this.chargeDocumentList();
          this.$parent.close();
        } catch (error) {
          this.$buefy.notification.open({
            message: "Error al ingresar documento!",
            type: "is-danger",
          });
        }
        this.isLoading = false;

      }else{
          this.$buefy.notification.open({
            message: "Ingrese todos los campos por favor!",
            type: "is-danger",
          });
      }


    },
  },
};
</script>